import firebase from 'firebase/app'
import 'firebase/database'
import 'firebase/storage'
import 'firebase/auth'
import "firebase/performance";
import "firebase/firestore";


// Initialize Firebase
var config = {
  apiKey: "AIzaSyCTBCk_kjyZkXhYD0kqLo677-amYDYg3kM",
  authDomain: "innovation-evotik.firebaseapp.com",
  databaseURL: "https://innovation-evotik-default-rtdb.firebaseio.com",
  projectId: "innovation-evotik",
  storageBucket: "innovation-evotik.appspot.com",
  messagingSenderId: "335563442392",
  appId: "1:335563442392:web:74629a936cd8ca8e0e6fad",
  measurementId: "G-B8NY8C16MY"
};
firebase.initializeApp(config);

const db = firebase.database();
const store = firebase.firestore();
const auth = firebase.auth();
const storageRef = firebase.storage().ref();
const perf = firebase.performance();

export {
  firebase,
  db,
  auth,
  store,
  perf,
  storageRef
};
